export default __webpack_public_path__ + "static/logo-small-8b521c88573a8ac5acee17703bcf345f.png";